export default __webpack_public_path__ + "static/header-image-c27bba37c28c9d9dd2359c9a3ad7c1c0.png";